import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  
  // Initialize state synchronously from localStorage
  const getInitialAuth = () => {
    if (location.state?.user) return true;
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    return token && user ? true : false;
  };

  const [isAuthenticated] = useState(getInitialAuth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
